import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-picker-gato',
  templateUrl: './picker-gato.component.html',
  styleUrl: './picker-gato.component.scss',
})
export class PickerGatoComponent {
  @Input() value: number[] = [];

  @Output() valueChanged = new EventEmitter<number[]>();

  changeItem(i: number, ev: CustomEvent | number) {
    if (typeof ev === 'number') {
      this.value[i] = ev;
    } else {
      this.value[i] = ev.detail.value;
    }
    this.valueChanged.emit(this.value);
  }
}
